import { BaseModel } from "./base.model";
export class FarmModel extends BaseModel {
    auto_id?: number;
    farmId: any;
    farmGrantNo: any;
    subDivId: any;
    farmFractionCount: any;
    farmVillageName: any;
    farmLotNo: any;
    farmAreaH: any;
    farmAreaAcre: any;
    farmAreaRelung: any;
    farmAreaHectare: any;
    lotRuleId: any;
    lotCatId: any;
    farmCloneType: any;
    farmPlantYear: any;
    farmNotes: any;
    farmLastUpdate: any;
    farmPersoUpdate: any;
    farmParlimen: any;
    farmDun: any;
    farmAgencyId: any;
    farmRubberTypeId: any;
    farmAreaRood: any;
    farmAreaPole: any;
    farmAreaJempa: any;
    farmAreaM2: any;
    farmPlantYearExceedDueYear: any;
    stateName: any;
    districtName: any;
    subDivName: any;
    cardNo: any;
    cardAgencyId: any;
    farmWorkerId: any;
    farmWorkerAreaHectare: any;
    farmWorkerAreaHectareWork: any;
    cardInProcess: any;
    agencyName: any;
    farmIsOwned: any;
    farmIsWorked: any;
    farmWorkerSubCatId: any;
    lotRuleName: any;
    lotCatName: any;
    grantImage1: string | null;
    grantImage2: string | null;
    grantImage3: string | null;
    grantImage4: string | null;
    grantImage5: string | null;
    grantImage1Id: string | null;
    grantImage2Id: string | null;
    grantImage3Id: string | null;
    grantImage4Id: string | null;
    grantImage5Id: string | null;
    permissionFormImage: string;
    appConfirmationFormImage: string;
    swornStatDecLetterImage: string;
    permissionFormImageId: string;
    appConfirmationFormImageId: string;
    swornStatDecLetterImageId: string;

    isOwn: any;
    isWork: any;
    workfarmWorkerAreaHectare: any;
    workfarmWorkerAreaHectareWork: any;

    patgRegId: number;
    patgRegStatusId: number;
    statusName: string;
    hasLetterOrReceiptLandAppTOL: any;
    hasLetterOrOfficialDocRelevantOffice: any;
    hasLetterOrReceiptChangeLandCondition: any;
    ownerType: any;
    hasOwnerHasLetterOrReceiptChangeLandCondition: any;
    hasOwnerHasLetterOrReceiptLandAppTOL: any;
    swornStatuoDecLetterTOL: any;
    swornStatuoDecLetterProveAsPentadbir: any;
    swornStatuoDecLetterChangeLandCond: any;
    appConfirmationFormPeribumi: any;
    appConfirmationFormPeneroka: any;
    appConfirmationFormAgency: any;
    appLandReceiptOrLetterTOL: any;
    officeLandDocOrLetter: any;
    changeLandCondReceiptOrLetter: any;
    ownerPermissionForm: any;
    appConfirmationForm: any;
    swornStatuoDecLetter: any;
    hasLandGrant: any;
    showReceiptChangeLotRuleQ: any;
    showLetterRelevantOfficerQ: any;
    showLetterOrReceiptLandOfficeQ: any;
    showLandGrantQ: any;
    showOwnerTypeQ: any;
    showPenerokaTOLQ: any;

    ownerPermissionFormId: string | null;
    appConfirmationFormId: string | null;
    swornStatuoDecLetterId: string | null;
    changeLandCondReceiptOrLetterId: string | null;
    officeLandDocOrLetterId: string | null;
    appLandReceiptOrLetterTOLId: string | null;
    appConfirmationFormAgencyId: string | null;
    appConfirmationFormPenerokaId: string | null;
    appConfirmationFormPeribumiId: string | null;
    swornStatuoDecLetterChangeLandCondId: string | null;
    swornStatuoDecLetterProveAsPentadbirId: string | null;
    swornStatuoDecLetterTOLId: string | null;
    /**
     * Default constructor
     * @param params Partial properties of Farm Model
     */
    constructor(params: Partial<FarmModel> = {} as FarmModel) {
        super();
        Object.assign(this, params);
    }

    static createCopy(objectToCopy: FarmModel | null): FarmModel | null {
        if (objectToCopy === null) return null;
        return (JSON.parse(JSON.stringify(objectToCopy)));
    }
}


